// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 102 ? "xlsx" : chunkId) + "." + {"102":"130a8da0","453":"89e64769"}[chunkId] + ".chunk.js";
};